import React, { useEffect, useRef } from 'react';

// Minimal theme: no animation loop, just a subtle radial glow that breathes
// very slowly. Static when the user prefers reduced motion.
export default function MinimalTheme({ palette, dark }) {
  const ref = useRef(null);
  const accent = palette?.[0] || '#3b82f6';

  useEffect(() => {
    const el = ref.current;
    if (!el || !el.animate) return undefined;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const anim = el.animate(
      [
        { opacity: 0.6, transform: 'scale(1)' },
        { opacity: 1, transform: 'scale(1.06)' },
        { opacity: 0.6, transform: 'scale(1)' },
      ],
      { duration: 9000, iterations: Infinity, easing: 'ease-in-out' }
    );
    return () => anim.cancel();
  }, []);

  return (
    <div
      ref={ref}
      className="absolute inset-0"
      style={{
        background: dark
          ? `radial-gradient(ellipse at center, ${accent}10 0%, transparent 70%)`
          : `radial-gradient(ellipse at center, ${accent}18 0%, transparent 70%)`,
      }}
    />
  );
}
